// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';
import Picture from 'app/common/ui-next/picture';

import styles from './ProductPhoto.scss';


type Props = {
  className?: string,
  alt: string,
  photoURL: string | null,
}

const ProductPhoto = ({ className, alt, photoURL }: Props): Node => {
  return (
    <div className={cn(styles.root, className)}>
      {photoURL
        ? <Picture
          alt={alt}
          className={styles.picture}
          src={photoURL}
          height="190px"
          width="150px"
        />
        : <PlainIcon
          width="80px"
          height="auto"
          type={iconTypes.NO_PHOTO}
        />}
    </div>
  );
};

export default ProductPhoto;
